import React from "react";
import Meta from "./../components/Meta";
import TestimonialsSection from "./../components/TestimonialsSection";
import TestimonialsSection2 from "./../components/TestimonialsSection2";

function TestimonialsPage(props) {
  return (
    <>
      <Meta title="Testimonials" />
      <TestimonialsSection
        bg="white"
        textColor="dark"
        size="md"
        bgImage=""
        bgImageOpacity={1}
        title="Here's what people are saying"
        subtitle=""
      />
      {/* <TestimonialsSection2
        bg="white"
        textColor="dark"
        size="md"
        bgImage=""
        bgImageOpacity={1}
        title="Here's what people are saying"
        subtitle=""
      /> */}
    </>
  );
}

export default TestimonialsPage;
